export default "__VITE_ASSET__C0mklL$t__"